import React from 'react';
import Select from 'epic-diesel-form/src/components/form/Select';
import {GatewayType} from '../../../../../../shared/types/payout/PayoutPublic';
import {useGetMessages} from '../../../../../hooks';

//@ts-ignore
import styles from './Payout.pcss';

export interface PayoutProps {
    gatewayType: GatewayType;
    trigger: (key: string, value: any) => void;
    disabled?: boolean;
}

const Payout: React.FC<PayoutProps> = ({gatewayType, trigger, disabled}) => {
    const messages = useGetMessages({
        title: 'epic.affiliate.settings.payout_title',
        desc: 'epic.affiliate.settings.payout_description',
        descDisabled: 'epic.affiliate.settings.tax.profile.payout.offline.payment.submitted.v2',
        paypal: 'label.affiliate.form.payoutInfo.accountType.paypal',
        bank: 'label.affiliate.form.payoutInfo.accountType.bank'
    });

    const methods = [
        {
            value: GatewayType.PAYPAL,
            label: messages.paypal
        },
        {
            value: GatewayType.WIRE_TRANSFER, // bank
            label: messages.bank
        }
    ];

    return (
        <div className={styles.section}>
            <h2>{messages.title}</h2>
            <p>{disabled ? messages.descDisabled : messages.desc}</p>
            <div className={styles.row}>
                <Select
                    name="gatewayType"
                    value={gatewayType}
                    options={methods}
                    onChange={trigger}
                    disabled={disabled}
                />
            </div>
        </div>
    );
};

export default Payout;
